import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private searchRefreshSource = new Subject<string>();

  searchRefreshEvt$ = this.searchRefreshSource.asObservable();

  refreshSearch() {
    this.searchRefreshSource.next();
  }

  constructor() { }
}
